import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";




export const addDiagnosis = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Diagnosis', body);
  return data;
});
export const updateDiagnosis = catchAsync(async (body, id) => {
  console.log(body, id);
  const { data } = await axiosInstance.put(`/api/resource/Diagnosis/${id}`, body);
  return data;
});

export const deleteDiagnosis = catchAsync(async (id) => {
  const { deleteDep } = await axiosInstance.delete(
    `/api/resource/Diagnosis/${id}`
  );
  return deleteDep;
});
export const getDiagnosisDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Diagnosis/${id}`
  );
  return data;
});
